<script setup lang="ts">
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';
import Tag from '@components/tag.vue';
import { useExpressPickComposable } from '@src/express-pick/express-pick-composable.js';

const { expressPickUser, expressPickWarehouses, assignWarehouse } = useExpressPickComposable();
</script>

<template>
    <HorizontalAlignChildrenWrapper v-if="expressPickUser" gap="1" :wrap-on-small-screen="false" wrap>
        <Tag
            v-for="warehouse in expressPickWarehouses"
            :key="warehouse.whsCode"
            :class="$style.warehouse"
            :tag-value="warehouse.whsCode"
            tag-color="lila"
            @click="() => assignWarehouse(warehouse)"
        />
    </HorizontalAlignChildrenWrapper>
</template>

<style lang="scss" module>
.warehouse {
    cursor: pointer;
}
</style>
